export default "__VITE_ASSET__DYWhPMeT__"